module.exports = __webpack_public_path__ + "static/img/tip-head.3754c983.webp";